const isAppName = (appName: string): boolean => {
  const app = process.env.REACT_APP_NAME
  return appName.toLowerCase() === app?.toLowerCase()
}

const getAppName = (): string => {
  return process.env.REACT_APP_NAME ?? 'ge'
}

const isTeaConnection = (): boolean => {
  return isAppName('tea')
}

export const ConfigUtils = {
  isAppName,
  isTeaConnection,
  getAppName,
}
